import React, {Component, PropTypes} from "react"
import {AutoSizer, VirtualScroll} from 'react-virtualized'
import 'react-virtualized/styles.css'

class VirtualList extends Component {
	recomputeRowHeights(i) {
		const {vsEl} = this
		if (!vsEl) {
			return
		}
		vsEl.recomputeRowHeights(i)
	}
	render() {
		const {gen, count, scrollPosition, row, noRows, rowHeight, rowWidth, visible, isPhone, isTablet} = this.props
		return (
			<AutoSizer>
				{({height, width}) => (
					<VirtualScroll
						style={{'display': visible ? 'block' : 'none'}}
						gen={gen}
						ref={el => {
							this.vsEl = el
						}}
						height={height}
						noRowsRenderer={noRows}
						rowHeight={rowHeight}
						rowRenderer={row}
						rowCount={count}
						scrollToIndex={scrollPosition}
						width={isPhone || isTablet ? Math.max(rowWidth, width) : Math.min(rowWidth, width)}
					/>
				)}
			</AutoSizer>
		)
	}
}
VirtualList.propTypes = {
	count: PropTypes.number,
}
export default VirtualList



// WEBPACK FOOTER //
// ./elements/VirtualList.jsx